/**
 * Created by maty on 14/02/2017.
 */

export class Sorting {
    by: string = "";
    direction: string = "";
}



// WEBPACK FOOTER //
// ./src/app/entities/sorting.ts